import { ArrowPathIcon, RocketLaunchIcon, ComputerDesktopIcon, HeartIcon, BeakerIcon, ArrowTrendingUpIcon } from '@heroicons/react/20/solid'

const features = [
  {
    name: 'سونوگرافی',
    description:
      'دستگاههای سونوگرافی و اکوکاردیوگرافی پرتابل کالر داپلر با کیفیت مورد تایید کادر پزشکان معتبر در زمینه رادیولوژی و سونوگرافی',
    href: '#',
    icon: ComputerDesktopIcon,
  },
  {
    name: 'فتال مانیتور و فتال داپلر',
    description:
      'نظارت بر جنین و شبیه سازی ضربان قلب با استفاده از اثر داپلر که یک روش غیر تهاجمی و بی خطر محسوب می شود.',
    href: '#',
    icon: RocketLaunchIcon,
  },
  {
    name: 'تست ورزش',
    description:
      'دستگاه استرس تست (تست ورزش) همراه با تردمیل و نوار قلب، جهت اندازه گیری فشار خون و ضربان قلب به طور مداوم ',
    href: '#',
    icon: ArrowPathIcon,
  },
  {
    name: 'هولتر ECG و فشار خون',
    description:
    'از بتدا تا تهیه گزارش نهایی طی یک دوره ۲۴ ساعته در محیط عادی و انجام فعالیت های بیمار، هدف ما کیفیت بالا و عملکرد برتر با قیمت مناسب است.',
    href: '#',
    icon: HeartIcon,
  },
  {
    name: 'پالس اکسی‌متر',
    description:
    'پالس اکسی‌متر دستی و رو میزی، با دقت بالا قابل استفاده در مطب و بیمارستان در انواع مختلف برای بزرگسالان، اطفال و نوزادان',    
    href: '#',
    icon: ArrowTrendingUpIcon,
  },
  {
    name: 'لوازم مصرفی',
    description:
    'لوازم مصرفی دستگاه های فتال مانیتورینگ، سونوگرافی و تست ورزش شامل پروب، رول کاغذ، دستکش جراحی و سایر لوازم مصرفی پزشکی مرتبط',    
    href: '#',
    icon: BeakerIcon,
  },
]

const FeatureSection = () => {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">تولید و واردات دستگاههای پزشکی و بیمارستانی</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
             سونوگرافی، زنان و زایمان، قلب و عروق
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900">
                  <feature.icon className="h-5 w-5 flex-none text-indigo-600" aria-hidden="true" />
                  {feature.name}
                </dt>
                <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                  <p className="mt-6">
                    <a href={feature.href} className="text-sm font-semibold leading-6 text-indigo-600">
                      ادامه مطلب <span aria-hidden="true">&larr;</span>
                    </a>
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}

export default FeatureSection;
